import {ApiClient} from './api'

// Function to be used for filtering shipping methods
const filterShippingMethods = (shippingMethods, isBopis) => {
    const filteredShippingMethods = isBopis
        ? {
              applicableShippingMethods: shippingMethods?.applicableShippingMethods?.filter(
                  (shippingMethod) => shippingMethod.c_storePickupEnabled
              )
          }
        : {
              ...shippingMethods,
              applicableShippingMethods: shippingMethods?.applicableShippingMethods?.filter(
                  (shippingMethod) =>
                      !shippingMethod.c_hideFromStorefront && !shippingMethod.c_storePickupEnabled
              )
          }
    return filteredShippingMethods
}

export class AdyenShippingMethodsService {
    baseUrl = '/api/adyen/shipping-methods'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async getShippingMethods(basketId, isBopis) {
        const res = await this.apiClient.get({
            headers: {
                basketid: basketId
            }
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            const shippingMethods = await res.json()
            const filteredShippingMethods = filterShippingMethods(shippingMethods, isBopis)
            return filteredShippingMethods
        }
    }

    async updateShippingMethod(shippingMethodId, basketId) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                shippingMethodId
            }),
            headers: {
                basketid: basketId
            }
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }
}
